import { render, staticRenderFns } from "./scope64.vue?vue&type=template&id=48b5c8d6&scoped=true"
import script from "./scope64.vue?vue&type=script&lang=js"
export * from "./scope64.vue?vue&type=script&lang=js"
import style0 from "./scope64.vue?vue&type=style&index=0&id=48b5c8d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b5c8d6",
  null
  
)

export default component.exports